import React, { memo, useEffect, useState } from "react";
import { Pie } from "@ant-design/plots";
import { Empty } from "antd";

const PieChart = props => {
  const { graphData, xField, yField } = props;

  const config = {
    appendPadding: 10,
    data: graphData,
    angleField: yField || "value",
    colorField: xField || "type",
    radius: 0.8,
    height: 320,
    label: {
      type: "outer",
      content: "{name} {percentage}",
    },
    interactions: [
      {
        type: "pie-legend-active",
      },
      {
        type: "element-active",
      },
    ],
  };

  return graphData?.length > 0 ? (
    <Pie {...config} />
  ) : (
    <Empty className="h-[320px] flex flex-col justify-center" />
  );
};

export default memo(PieChart); // converted into pure component to prevent unwanted rendering
